import { ReactNode } from "react"

export interface ErrorMessageProps {
  children: ReactNode
}

export const ErrorMessage = ({ children }: ErrorMessageProps) => {
  return <div style={{ lineHeight: 1.5, color: "red" }}>{children}</div>
}
